import React, { useState } from "react";
//import { useForm } from "../../../hooks/useForm";
import { useDispatch } from "react-redux";
import { Button } from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import { STEPPER_MEDICACION } from "../../../utils/constants";
import {
    setActiveStep,
    setShowForm,
} from "../../../actions/empadronamiento/Empadronamiento";
import { MedicacionAccordionDocumentacion } from "./Accordions/MedicacionAccordionDocumentacion";
import { MedicacionCard } from "../UI/MedicacionCard";

export const MedicacionDocumentacionDetalle = (props) => {
    const dispatch = useDispatch();
    const [datosCompletosDocumentacion, setDatosCompletosDocumentacion] = useState(false);

    /*
    const [
      formValues,
      ,
      ,
      setearValor,
      ,
      ,
      ,
      ,
      ,
    ] = useForm(
      solicitudSeleccionada
    );
  
    const {
      fechaInicio = new Date()
    } = formValues;
    */

    const submitHandler = () => {
        dispatch(setActiveStep(STEPPER_MEDICACION.MEDICAMENTOS));
    };

    return (
        <React.Fragment>
            <MedicacionCard width={"55%"}>
                <ValidatorForm onSubmit={submitHandler}>
                    <MedicacionAccordionDocumentacion
                        datosCompletos={datosCompletosDocumentacion}
                        setDatosCompletos={setDatosCompletosDocumentacion}
                    />

                    <div
                        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
                    >
                        <Button
                            variant="contained"
                            color="secondary"
                            style={{ marginRight: "3rem" }}
                            onClick={() => {
                                dispatch(setActiveStep(STEPPER_MEDICACION.DETALLE));
                                dispatch(setShowForm(false));
                            }}
                        >
                            Anterior
                        </Button>
                        <Button variant="contained" color="primary" type="submit" disabled={!datosCompletosDocumentacion}>
                            Siguiente
                        </Button>
                    </div>
                </ValidatorForm>
            </MedicacionCard>
        </React.Fragment>
    );
};
